const DpoCoreNastenkaUpozorneni = {
    seznam: [],

    init: function() {
        const upozorneni = $("#nastenka-upozorneni");
        if (!upozorneni.length) {
            return;
        }

        const seznam = upozorneni.find("div");
        if (!seznam.length) {
            return;
        }

        $.each(seznam, function(i, v) {
            let uuid = $(v).html();
            uuid = uuid.trim();
            if (uuid.length) {
                DpoCoreNastenkaUpozorneni.seznam.push(uuid);
            }
        });

        let uuid = DpoCoreNastenkaUpozorneni.seznam.shift();
        if (typeof uuid !== "undefined") {
            DpoCoreNastenkaUpozorneni.zobrazUpozorneni(uuid);
        }
    },

    zobrazUpozorneni: function(uuid) {
        let url = window.location.protocol + "//" + window.location.host;
        url += "/ajax/core/nactiUpozorneni";

        $.ajax({
            type: "post",
            url: url,
            data: { "uuid": uuid },
            dataType: "json",
            global: true,
            success: function(r) {
                if (r.hasOwnProperty("messages")) {
                    Lemo_Alert.addMany(r.messages);
                }

                if (r.hasOwnProperty("status") && true !== r.status) {
                    return;
                }

                WilleModal.setId("modal-" + uuid);
                WilleModal.disableClose();
                WilleModal.setTitle('Upozornění');
                WilleModal.setContent(r.html);
                WilleModal.setSize("large");
                WilleModal.addButton("confirm", "<i class=\"fa fa-fw fa-check\"></i> Rozumím", "btn btn-primary", function() {
                    Promise.all([
                        WilleModal.close(),
                        DpoCoreNastenkaUpozorneni.akceptujUpozorneni(uuid)
                    ]).then(() => {
                        uuid = DpoCoreNastenkaUpozorneni.seznam.shift();
                        if (typeof uuid !== "undefined") {
                            DpoCoreNastenkaUpozorneni.zobrazUpozorneni(uuid);
                        }
                    }).catch((messages) => {
                        console.log(messages);
                    });
                });
                WilleModal.build();
            }
        });
    },

    akceptujUpozorneni: function(uuid) {
        let url = window.location.protocol + "//" + window.location.host;
        url += "/ajax/core/akceptujUpozorneni";

        return new Promise((resolve, reject) => {
            $.ajax({
                type: "post",
                url: url,
                data: { "uuid": uuid },
                dataType: "json",
                global: true,
                success: function(r) {
                    if (r.hasOwnProperty("messages")) {
                        Lemo_Alert.addMany(r.messages);
                    }

                    resolve("notification accepted");
                },
                error: function(xhr) {
                    reject(xhr.error());
                }
            });
        });
    }
};

$(document).ready(function() {
    DpoCoreNastenkaUpozorneni.init();
});